import { IBaseDataList } from '@game-studio/arcade-base';

export const coreDataList: IBaseDataList = {
    assetList: {
        data: [{ name: 'core-asset-list', url: `asset-list.json` }]
    },
    skin: 'core',
    version: 'ver-1.0.0'
};
